import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var checkActiveIds = function checkActiveIds(_ref) {
  var option = _ref.option,
    value = _ref.value,
    isMultiSelect = _ref.isMultiSelect;
  if (!isMultiSelect) {
    return option.id;
  }
  var valueIsNotEmptyArray = !!value && Array.isArray(value) && value[0] !== '' && value[0] !== 0;
  var resultToSend;
  var allActiveIds = valueIsNotEmptyArray ? value : [];
  var isChosenOptionNew = allActiveIds.includes(option.id);
  if (isChosenOptionNew) {
    resultToSend = allActiveIds.filter(function (elem) {
      return elem !== option.id;
    });
  } else {
    resultToSend = [].concat(_toConsumableArray(allActiveIds), [option.id]);
  }
  return resultToSend;
};